<template>
  <div class="no-login" v-show="!islogin">
    <div class="no-login-ico"></div>
  	<div class="no-login-info">请先登录后再去操作</div>
    <span class="btn btn-blue" @click="$router.push({name: 'login'})">去登录</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      islogin: this.$store.getters.islogin
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-login{ text-align: center;}
.no-login-ico{ width: 2.4rem; height: 2.4rem; background: url(../../assets/images/ico_denglu.png) no-repeat center/cover; border-radius: 50%; margin: 0.1rem auto 0.2rem;}
.no-login-info{ margin-bottom: 0.3rem; font-size: 0.3rem; font-weight: normal; }
	 

</style>



// WEBPACK FOOTER //
// src/components/basic/nologin.vue